import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="container-site grid gap-10 py-14 md:grid-cols-4 md:py-16">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-2-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950">
              漫画<span className="text-primary-500">岛</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            漫画岛专注舒适阅读体验,高清原图、横屏观看、夜间模式与舒适翻页,长时间追漫不累眼。
          </p>
          <div className="mt-5 flex gap-3">
            <a
              href="#"
              aria-label="微博"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="#"
              aria-label="微信公众号"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-wechat-line"></i>
            </a>
            <a
              href="#"
              aria-label="哔哩哔哩"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-foreground-950">热门分类</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
            {categories.slice(0, 8).map((c) => (
              <li key={c.id}>
                <Link
                  to={`/category/${c.id}`}
                  className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-500"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-foreground-950">快速导航</h4>
          <ul className="flex flex-col gap-2.5">
            <li>
              <Link to="/" className="text-sm text-foreground-700 hover:text-primary-500">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category/all" className="text-sm text-foreground-700 hover:text-primary-500">
                全部漫画
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-500">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-foreground-950">联系我们</h4>
          <ul className="flex flex-col gap-2.5 text-sm text-foreground-700">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              <span>support@comic-island.example.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-primary-500"></i>
              <span>400-888-8888</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-primary-500"></i>
              <span>中国 · 北京 · 朝阳区</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-site flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 漫画岛 Comic Island.保留所有权利。
          </p>
          <p className="text-xs text-foreground-600">
            <span className="whitespace-nowrap">本平台内容仅供学习交流,请支持正版漫画。</span>
          </p>
        </div>
      </div>
    </footer>
  );
}